/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyLegalDetails
 */
export interface CompanyLegalDetails {
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalDetails
     */
    externalProviderId: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalDetails
     */
    externalProviderName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalDetails
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLegalDetails
     */
    registrationNumber: string;
}

/**
 * Check if a given object implements the CompanyLegalDetails interface.
 */
export function instanceOfCompanyLegalDetails(value: object): value is CompanyLegalDetails {
    if (!('externalProviderId' in value) || value['externalProviderId'] === undefined) return false;
    if (!('externalProviderName' in value) || value['externalProviderName'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    return true;
}

export function CompanyLegalDetailsFromJSON(json: any): CompanyLegalDetails {
    return CompanyLegalDetailsFromJSONTyped(json, false);
}

export function CompanyLegalDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyLegalDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'externalProviderId': json['externalProviderId'],
        'externalProviderName': json['externalProviderName'],
        'countryCode': json['countryCode'],
        'registrationNumber': json['registrationNumber'],
    };
}

export function CompanyLegalDetailsToJSON(value?: CompanyLegalDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'externalProviderId': value['externalProviderId'],
        'externalProviderName': value['externalProviderName'],
        'countryCode': value['countryCode'],
        'registrationNumber': value['registrationNumber'],
    };
}

